export default __webpack_public_path__ + "static/media/1_0056.e26d050c.webp";